'use strict';

var React = require('react');

module.exports = function (props) {
    return React.createElement('svg', Object.assign({ viewBox: '0 0 1024 1024' }, props), React.createElement(
        'g',
        null,
        React.createElement('path', { d: 'M128 320h-128v-256c0-35.346 28.654-64 64-64h256v128h-192v192z' }),
        React.createElement('path', { d: 'M1024 320h-128v-192h-192v-128h256c35.346 0 64 28.654 64 64v256z' }),
        React.createElement('path', { d: 'M960 1024h-256v-128h192v-192h128v256c0 35.346-28.654 64-64 64z' }),
        React.createElement('path', { d: 'M320 1024h-256c-35.346 0-64-28.654-64-64v-256h128v192h192v128z' })
    ));
};